export const generatePlaceholders = (items) => {
  const remainingItemsForFullRow = items.length % 3
  const placeholdersNeeded =
    remainingItemsForFullRow === 0 ? 0 : 3 - remainingItemsForFullRow

  const placeholders = Array(placeholdersNeeded).fill({ isPlaceholder: true })

  return [...items, ...placeholders]
}
